import { Object3D, Quaternion } from "three";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
import { Ticker } from "pixi.js";

export class StunningParticle extends Object3D {
    private particle: Object3D;

    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly batchRenderer: BatchedRenderer
    ) {
        super();
        this.particle = clone(this.gameResources.assets_game_particles_stunning_thjson);
        this.particle.position.set(0, 0.5, 0);
        QuarksUtil.setAutoDestroy(this.particle, true);
        QuarksUtil.addToBatchRenderer(this.particle, this.batchRenderer);
        QuarksUtil.play(this.particle);
        this.add(this.particle);
        Ticker.shared.add(this.onTick, this);
    }

    public onTick(_dt: number) {
        const parentQuat = this.parent.getWorldQuaternion(new Quaternion());
        this.quaternion.copy(parentQuat).invert();
    }

    public dispose() {
        Ticker.shared.remove(this.onTick, this);
        if (this.parent) {
            this.parent.remove(this);
        }
    }
}